"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Errors = void 0;

var Errors =
/*#__PURE__*/
function () {
  function Errors() {
    _classCallCheck(this, Errors);
  }

  _createClass(Errors, null, [{
    key: "canntFindAction",
    value: function canntFindAction(pageName) {
      var msg = "Cannt find action in page '".concat(pageName, "', is the exports has default field?");
      return new Error(msg);
    }
  }, {
    key: "exportsCanntNull",
    value: function exportsCanntNull(pageName) {
      var msg = "Exports of page '".concat(pageName, "' is null.");
      return new Error(msg);
    }
  }, {
    key: "containerNotExist",
    value: function containerNotExist(containerName) {
      var msg = "Container ".concat(containerName, " is not exists.");
      return new Error(msg);
    }
  }]);

  return Errors;
}();

exports.Errors = Errors;
//# sourceMappingURL=errors.js.map
